import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { AppService } from '../shared/service/AppService.class';
import { AppService } from '../shared/service/AppService.class';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "emailgroup";
  }

  getHeaders(data?:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/getHeaders'
    let result = super.getService(data);
    this.appmod=tmp
    return result;
  }
  saveGroup(data?:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/saveEmailgroup'
    let result = super.saveService(data);
    this.appmod=tmp
    return result;
  }
  DeleteGroup(id:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/DeleteEmailgroup'
    let result = super.deleteService(id);
    this.appmod=tmp
    return result;
  }
  getRecord(): Observable<any>{
    let tmp=this.appmod
    this.appmod='smtpRecords';
    let result = super.getService();
    this.appmod=tmp
    return result;
  }
  saveEmailSetting(data?:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/saveEmailSetting'
    let result = super.saveService(data);
    this.appmod=tmp
    return result;
  }
  updateEmailgroup(data:any,id:any):Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/UpdateEmailSetting'
    let result = super.updateService(data,id);
    this.appmod=tmp
    return result;
  }

  getEmailData(): Observable<any>{
    let tmp=this.appmod
    this.appmod='custome/GetEmailgroup'
    let result = super.getService();
    this.appmod=tmp
    return result;
  }
  getlistemail(data:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/Listemail'
    let result = super.getService(data);
    this.appmod=tmp
    return result;
  }
  getlistemailbyID(data:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='Listemail'
    let result = super.getService('undefined','undefined',data);
    this.appmod=tmp
    return result;
  }
  getgroupname(where?:any):Observable<any>{
    let tmp=this.appmod
    this.appmod='groupname'
    let result = super.getService('undefined','undefined',where);
    this.appmod=tmp
    return result;
  }
  listfullemail(): Observable<any>{
    let tmp=this.appmod
    this.appmod='Listfullemail'
    let result = super.getService();
    this.appmod=tmp
    return result;
  }
  saveSMTP(data:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/savesmtp'
    let result = super.saveService(data);
    this.appmod=tmp
    return result;
  }
  deleteEmail(data:any): Observable<any>{
    let tmp=this.appmod
    this.appmod='custom/deletesmtp'
    let result = super.saveService(data);
    this.appmod=tmp
    return result;
  }
}
